import { z } from 'zod';
// ====== STATUS ID SCHEMA ======
// Status is managed via status_id foreign key to the statuses table
export const statusIdSchema = z.string().uuid('Invalid status_id UUID format').optional().nullable();
// ====== FIELD LENGTH LIMITS ======
export const MAX_NAME_LENGTH = 255;
export const MAX_ADDRESS_LENGTH = 500;
export const MAX_NOTES_LENGTH = 2000;
export const MAX_PHONE_LENGTH = 20;
export const MAX_EMAIL_LENGTH = 255;
export const MAX_CITY_LENGTH = 100;
export const MAX_STATE_LENGTH = 100;
export const MAX_COUNTRY_LENGTH = 100;
export const MAX_INVOICE_NUMBER_LENGTH = 100;
export const MAX_CURRENCY_LENGTH = 3;
export const MAX_PAYMENT_TERMS_LENGTH = 100;
export const MAX_PO_NUMBER_LENGTH = 100;
// ====== COMMON FIELD VALIDATORS ======
export const phoneSchema = z
    .string()
    .max(MAX_PHONE_LENGTH, `Phone must be ${MAX_PHONE_LENGTH} characters or less`)
    .regex(/^[\d\s\-\+\(\)]*$/, 'Phone contains invalid characters')
    .optional()
    .or(z.literal(''))
    .nullable();
export const emailSchema = z
    .string()
    .max(MAX_EMAIL_LENGTH, `Email must be ${MAX_EMAIL_LENGTH} characters or less`)
    .email('Invalid email format')
    .optional()
    .or(z.literal(''))
    .nullable();
export const uuidSchema = z.string().uuid('Invalid UUID format');
export const dateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in YYYY-MM-DD format');
export const optionalDateSchema = dateSchema.optional().or(z.literal('')).nullable();
//# sourceMappingURL=common.js.map